import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'fileIcon',
  standalone: false
})
export class FileIconPipe implements PipeTransform {
  transform(fileName: string): string {
    fileName = fileName.toUpperCase();
    return fileName.substring(fileName.lastIndexOf('.') + 1);
  }
}
